import { Tooltip as MuiTooltip, TooltipProps as MuiTooltipProps } from '@mui/material';

import { getTooltipSlotProps, TooltipChildrenWrapper } from './Tooltip.style';

export type AdditionalTooltipProps = { isChildDisabled?: boolean };
type TooltipProps = MuiTooltipProps & AdditionalTooltipProps;

export const Tooltip = ({ isChildDisabled, title, children }: TooltipProps): JSX.Element => {
  const slotProps = getTooltipSlotProps(isChildDisabled);
  return (
    <MuiTooltip
      slotProps={slotProps}
      title={title}
      enterDelay={400}
      placement="bottom-start"
      PopperProps={{ disablePortal: true }}
    >
      <TooltipChildrenWrapper>{children}</TooltipChildrenWrapper>
    </MuiTooltip>
  );
};
